import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import styles from './Data.module.scss'
import { Card, H5, FormGroup, InputGroup } from '@blueprintjs/core'
import Search from 'shared/search'
import DataObject from './DataObject.js'
import { intl } from 'i18n/IntlGlobalProvider'
import CreateOrSaveDialog from './DataObjectItemDialog'
import store from 'store'
import { addContextDataObject } from './actions'
import api from './api'
import { InputEmployee } from 'shared/Forms'

const CreateNewExludedCrewMember = (props) => {
  const error =
    props.isOpen === 'new'
      ? props.validation_errors?.[props.dataObject.payload.items.length]
      : props.validation_errors?.[props.isOpen]
  const [isInvalid, setIsInvalid] = useState(props.isOpen === 'new' ? true : false)
  useEffect(() => setIsInvalid(props.isOpen === 'new' ? true : false), [props.isOpen])
  return (
    <CreateOrSaveDialog
      usePortal={false}
      payload={props.dataObject.payload}
      id={props.dataObject.id}
      icon="info-sign"
      title="Pre-assigned Weekend"
      edit={props.isOpen >= 0 && props.isOpen !== 'new'}
      resetObject={''}
      isInvalid={isInvalid}
      onClose={props.onClose}
      onSave={props.onSave}
      isOpen={props.isOpen}>
      {(data, setData) => (
        <FormGroup label="Employee" inline>
          <InputEmployee
            value={data}
            onChange={(employee, invalid) => {
              setData(employee)
              if (invalid) setIsInvalid(true)
              else setIsInvalid(false)
            }}
          />
        </FormGroup>
      )}
    </CreateOrSaveDialog>
  )
}

const PreAssignedWeekends = ({ is_editable, data, search, onClick }) => {
  return (
    <>
      {data.payload?.items?.map((item, i) => (
        <Card
          style={{
            margin: 10,
            display: item.toUpperCase().includes(search.toUpperCase()) ? 'block' : 'none',
          }}
          className={styles.card}
          key={i}
          onClick={
            is_editable
              ? (e) => {
                  e.stopPropagation()
                  onClick(i)
                }
              : undefined
          }
          interactive={is_editable}>
          <H5 style={{ display: 'inline-block', margin: 0 }}>{item.toUpperCase()}</H5>
        </Card>
      ))}
    </>
  )
}
const Comp = (props) => {
  const [dialog, setDialog] = useState(null)
  const { data } = props
  const [search, setSearch] = useState('')
  const { is_editable } = data
  return (
    <>
      <CreateNewExludedCrewMember
        validation_errors={data.validation_errors?.items}
        isOpen={dialog}
        dataObject={props.data}
        onSave={props.onSave}
        onClose={() => {
          setDialog(null)
        }}
      />
      <DataObject
        data={props.data}
        upload="json"
        title={intl.t('pre_assigned_weekends')}
        search={
          <Search
            value={search}
            placeholder="Employee"
            onChange={(value) => {
              setSearch(value)
            }}
          />
        }
        is_editable={is_editable}
        onAdd={() => setDialog('new')}
        onChange={(data) => store.dispatch(addContextDataObject(data))}
        onUndo={() => api.getDataObject(data.id)}
        onSave={props.onSave}>
        <PreAssignedWeekends is_editable={is_editable} data={data} search={search} onClick={setDialog} />
      </DataObject>
    </>
  )
}

export default Comp
